<template>
  <div class="content-box">
    <div class="page-title">
      当前位置：首页 > 机构信息
    </div>
    <div class="content-info">
      <h3 class="form-title flex-center">
        机构信息 <span>（状态：<b v-if="state === 0">未提交</b><b v-if="state === 1">已提交</b><b v-if="state === 2">审核中 </b><b
        v-if="state === 3" style="color: #d50000">审核未通过</b><b v-if="state === 4">审核中</b><b
        v-if="state === 5">审核通过</b><b
        v-if="state === 6">审核未通过</b>）</span>
        <p>标 “ <b>*</b> ” 为必填项，已导入信息不可修改</p>
      </h3>
      <p class="padding-sm reason" v-if="state === 3">拒绝原因：{{ reason }}</p>
      <div class="form-step flex-center ">
        <span class="margin-right active">第一步：机构信息</span>
        <span>第二步：设置网店</span>
      </div>
      <div class="step-box">
        <div class="step-title">
          <div class="step-title-text">
            1.基本信息
          </div>
        </div>
        <div class="padding">
          <el-form ref="form1" :model="importInfo" label-width="180px">

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="组织名称：" class="margin-bottom-xs">
                  <el-input v-model="importInfo.text1" disabled></el-input>
                </el-form-item>
<!--                <el-form-item label="登记证件号：" class="margin-bottom-xs">-->
<!--                  <el-input v-model="importInfo.text2" disabled></el-input>-->
<!--                </el-form-item>-->
              </el-col>
              <el-col :span="12">
                <el-form-item label="注册资金：" class="margin-bottom-xs">
                  <el-input v-model="importInfo.text3" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="统一社会信用代码：" class="margin-bottom-xs">
                  <el-input v-model="importInfo.text4" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="住所：" class="margin-bottom-xs">
                  <el-input v-model="importInfo.text5" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="法定代表人/负责人：" class="margin-bottom-xs">
                  <el-input v-model="importInfo.text6" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="社会组织类型：" class="margin-bottom-xs">
                  <el-input v-model="importInfo.text7" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="业务主管单位：" class="margin-bottom-xs">
                  <el-input v-model="importInfo.text8" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="成立日期：" class="margin-bottom-xs">
                  <el-input v-model="importInfo.text9" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="登记机关：" class="margin-bottom-xs">
                  <el-input v-model="importInfo.text10" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="登记状态：" class="margin-bottom-xs">
                  <el-input v-model="importInfo.text11" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="业务范围：" class="margin-bottom-xs">
              <el-input type="textarea" v-model="importInfo.text12" disabled rows="6"></el-input>
            </el-form-item>
            <el-form-item label="评估信息：" class="margin-bottom-xs">
              <el-row class="tan-title">
                <el-col :span="8" class="text-center">评估等级</el-col>
                <el-col :span="8" class="text-center">审定机关</el-col>
                <el-col :span="8" class="text-center">评估有效期</el-col>
              </el-row>
              <el-row class="tan-info">
                <el-col :span="8" class="text-center">
                  <div v-for="(item,index) in importInfo.text13" :key="index">
                    <span style="padding: 0 5px">{{ item }}</span>
                  </div>
                </el-col>
                <el-col :span="8" class="text-center">
                  <div v-for="(item,index) in importInfo.text14" :key="index">
                    <span style="padding: 0 5px">{{ item }}</span>
                  </div>
                </el-col>
                <el-col :span="8" class="text-center">
                  <div v-for="(item,index) in importInfo.text15" :key="index">
                    <span style="padding: 0 5px">{{ item }}</span>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="年报信息：" class="margin-bottom-xs">
              <el-row class="tan-title">
                <el-col :span="12" class="text-center">年检（年报）年度</el-col>
                <el-col :span="12" class="text-center">年检（年报）结论</el-col>
              </el-row>
              <el-row class="tan-info">
                <el-col :span="12" class="text-center">
                  <div v-for="(item,index) in importInfo.text16" :key="index">
                    <span style="padding: 0 5px">{{ item }}</span>
                  </div>
                </el-col>
                <el-col :span="12" class="text-center">
                  <div v-for="(item,index) in importInfo.text17" :key="index">
                    <span style="padding: 0 5px">{{ item }}</span>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>

          </el-form>
        </div>
        <div class="hr-solid"></div>
        <div class="padding">
          <el-form ref="form2" :model="orgInfo" :rules="rules" label-width="180px">
            <el-form-item label="秘书处地址：" prop="address">
              <el-input v-model="orgInfo.address" :disabled="state === 2 || state ===4 || state === 5"></el-input>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="秘书处专职人员(人数)：" prop="msZZ">
                  <el-input type="number" v-model="orgInfo.msZZ" :disabled="state === 2 || state ===4 || state === 5"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" prop="dyNum">
                <el-form-item label="党员数量(人数)：" prop="dyNum">
                  <el-input type="number" v-model="orgInfo.dyNum" :disabled="state === 2 || state ===4 || state === 5"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="党支部名称：" >
                  <el-input placeholder="(如未成立，可不填写)" v-model="orgInfo.dzbName" :disabled="state === 2 || state ===4 || state === 5"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="机构网站：：">
                  <el-input v-model="orgInfo.orgWeb" :disabled="state === 2 || state ===4 || state === 5"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系人：" prop="name">
                  <el-input v-model="orgInfo.name" :disabled="state === 2 || state ===4 || state === 5"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话：" prop="phone">
                  <el-input v-model="orgInfo.phone" :disabled="state === 2 || state ===4 || state === 5"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="电子邮箱：" prop="email">
              <el-input v-model="orgInfo.email" :disabled="state === 2 || state ===4 || state === 5"></el-input>
            </el-form-item>

            <el-form-item label="上传LOGO(3MB以内)：">
              <div class="up-file-box">
                <upFile :img-title="'logo'" :accept="'image/*'" @setImg="setImg"
                        v-if="state !== 2 && state !==4 && state!==5"></upFile>
                <div class="up-img" v-if="orgInfo.logo">
                  <img class="logo" :src="orgInfo.logo" alt="">
                </div>
              </div>
            </el-form-item>

          </el-form>
        </div>
      </div>
      <div class="step-solid margin-bottom"></div>
      <div class="step-box">
        <div class="step-title flex-center">
          <div class="step-title-text">
            2.组织风采
          </div>
          <div class="step-title-tips">
            <span>提示：</span>可上传团队建设、品牌活动、调研座谈、获得评比达标表彰资质信息、承接政府购买服务信息、承接政府转移职能信息、资格信息等图片。
          </div>
        </div>
        <div class="padding">
          <el-row :gutter="30">
            <el-col :span="24" v-for="(item,index) in fcArr" :key="index">
              <div class="demeanour-item ">
                <el-row :gutter="30">
                  <el-col :span="16">
                    <div class="flex-start"><span>专题分类:</span>
                      <p>{{ item.type_name }}</p></div>
                    <div class="flex-start"><span>标<b></b>题:</span>
                      <p>{{ item.title }}</p></div>
                    <div class="flex-start"><span>介<b></b>绍:</span>
                      <p>{{ item.detail }}</p>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div><span>照<b></b>片：</span><img :src="item.img_url" alt=""></div>
                    <div class="demeanour-item-btn" v-if="state !== 2 && state !==4 && state!==5">
                      <el-button type="warning" @click="editItem(index)">编辑</el-button>
                      <el-button type="danger" @click="closeItem(index)">删除</el-button>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-button type="warning" class="add-item-btn" @click="hadleOpen('')" v-if="state !== 2 && state !==4 && state!==5">
            添加组织风采
          </el-button>
        </div>
      </div>
      <div class="operate" v-if="state === 0 || state === 1|| state === 3|| state === 6">
        <el-button class="operate-submit" @click="saveForm('form2')">保存</el-button>
        <el-button class="operate-next" @click="submitForm('form2')">下一步</el-button>

      </div>
    </div>

    <el-dialog
      title="组织风采编辑"
      :visible.sync="dialogVisible"
      width="800px"
      center
      :before-close="handleClose">
      <div class="dislog-from">
        <el-form :model="formFc" :rules="rulesFc" ref="formFc" label-width="150px" class="demo-ruleForm">
          <el-form-item label="专题分类" prop="type">
            <el-select v-model="formFc.type" placeholder="请选择专题分类" style="width: 100%;">
              <el-option v-for="item in typeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标题" prop="name">
            <el-input v-model="formFc.name" placeholder="请输入标题(30字以内)" maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="介绍">
            <el-input v-model="formFc.desc" rows="4" type="textarea" maxlength="150" placeholder="请输入介绍(150字以内)" ></el-input>
          </el-form-item>
          <el-form-item label="照片：" prop="img">
            <div class="up-file-box">
              <upFile :img-title="'fc'" :accept="'image/*'" @setImg="setImg"></upFile>
              <div class="up-img" v-if="formFc.img">
                <img class="logo" :src="formFc.img" alt="">
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="editFc('formFc')">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import upFile from "../../components/upFile";
// import upFile2 from "../../components/upFile2";

export default {
  name: "orgInfo",
  components: {
    upFile,
    // upFile2
  },
  data() {
    return {
      state: '',   //  0未提交；1已提交待审核 2审核通过 3：审核未通过 4：锁定
      reason: '',//  未通过原因
      importInfo: {
        text1: '',
        text2: '',
        text3: '',
        text4: '',
        text5: '',
        text6: '',
        text7: '',
        text8: '',
        text9: '',
        text10: '',
        text11: '',
        text12: '',
        text13: '',
        text14: '',
        text15: '',
        text16: '',
        text17: '',
      },  //  机构倒入信息
      orgInfo: {
        address: '',     //秘书处地址
        msZZ: '',        //秘书处专职人员
        dyNum: '',       //党员数量
        dzbName: '',     //党支部名称
        orgWeb: '',      //机构网站
        name: '',        //联系人
        phone: '',       //联系电话
        email: '',       //电子邮箱
        logo: '',        //上传LOGO
      },      //  机构填写信息
      rules: {
        address: [
          {required: true, message: '请输入秘书处地址', trigger: 'blur'},
        ],
        msZZ: [
          {required: true, message: '请输入秘书处专职人员', trigger: 'blur'},
        ],
        dyNum: [
          {required: true, message: '请输入党员数量', trigger: 'blur'},
        ],
        // dzbName: [
        //   {required: true, message: '请输入党支部名称', trigger: 'blur'},
        // ],
        // orgWeb: [
        //   {required: true, message: '请输入机构网站', trigger: 'blur'},
        // ],
        name: [
          {required: true, message: '请输入联系人', trigger: 'blur'},
        ],
        phone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
        ],
        email: [
          {required: true, message: '请输入电子邮箱', trigger: 'blur'},
          {type: 'email', message: '请输入正确的电子邮箱', trigger: 'blur'},
        ],
        // logo: [
        //   {required: true, message: '请上传LOGO', trigger: 'change'},
        // ]
      },  //  规则
      fcArr: [],     //  风采
      typeArr: [],   //  专题分类
      fcsubmitState:true,
      dialogVisible: false, //  弹框状态
      setId: '',     //  风采修改id
      formFc: {
        type: '',
        name: '',
        desc: '',
        img: '',
      },
      rulesFc: {
        type: [
          {required: true, message: '请选择专题分类', trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入标题', trigger: 'blur'},
        ],
        img: [
          {required: true, message: '请上传照片', trigger: 'change'},
        ]
      }

    }
  },
  created() {
    this.$emit('setIndex', 0)
    this.getOrgInfo()
    this.typeList()
  },
  methods: {
    /*
    * 编辑风采
    * */
    editItem(index) {
      this.formFc = {
        type: Number(this.fcArr[index].type),
        name: this.fcArr[index].title,
        desc: this.fcArr[index].detail,
        img: this.fcArr[index].img_url,
      }
      this.hadleOpen(this.fcArr[index].id)
    },
    /*
    * 删除风采
    * */
    closeItem(index) {
      this.$confirm('您确定要删除当前风采吗?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        type: 'warning'
      }).then(() => {
        this.$api.apiContent.closeOrganization({
          token: this.$store.state.user.token,
          id: this.fcArr[index].id
        }).then(() => {
          this.$message.success('删除成功')
          this.getOrgInfo()
        }).catch(e => {
          this.$message.error(e.msg)
        })
      }).catch(() => {

      });
    },
    /*
    * 添加/修改风采
    * */
    editFc(formName) {
      if(!this.fcsubmitState) return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fcsubmitState = false
          if (this.setId) {
            this.$api.apiContent.organizationEdit({
              token: this.$store.state.user.token,
              type: this.formFc.type,
              title: this.formFc.name,
              detail: this.formFc.desc,
              img_url: this.formFc.img,
              id: this.setId,

            }).then(() => {
               this.fcsubmitState = true
              this.$message.success('修改成功')
              this.getOrgInfo2()
              this.handleClose()
            }).catch(e => {
               this.fcsubmitState = true
              this.$message.error(e.msg)
            })
          } else {
            this.$api.apiContent.organizationAdd({
              token: this.$store.state.user.token,
              type: this.formFc.type,
              title: this.formFc.name,
              detail: this.formFc.desc,
              img_url: this.formFc.img,
            }).then(() => {
               this.fcsubmitState = true
              this.$message.success('添加成功')
              this.getOrgInfo2()
              this.handleClose()
            }).catch(e => {
               this.fcsubmitState = true
              this.$message.error(e.msg)
            })
          }
        } else {
          this.$message.error('信息未填写完整，请确认')
        }
      });


    },
    /*
    * 打开弹框
    * */
    hadleOpen(id) {
      this.setId = id
      this.dialogVisible = true
      if(!this.setId){
        this.$refs['formFc'].clearValidate();
      }
    },
    /*
    * 关闭弹框
    * */
    handleClose() {
      this.setId = ''
      this.formFc = {
        type: '',
        name: '',
        desc: '',
        img: '',
      }
      this.dialogVisible = false
    },
    /*
    * 提交基本信息
    * */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.fcArr.length === 0) {
            this.$message.error('请填写组织风采')
            return
          }
          this.$api.apiContent.mechanismSaveorupdate({
            token: this.$store.state.user.token,
            secretariat_address: this.orgInfo.address,
            major_num: this.orgInfo.msZZ,
            party_num: this.orgInfo.dyNum,
            party_name: this.orgInfo.dzbName,
            website: this.orgInfo.orgWeb,
            contacts: this.orgInfo.name,
            phone: this.orgInfo.phone,
            email: this.orgInfo.email,
            logo_url: this.orgInfo.logo,
          }).then(() => {
            this.$store.state.user.head_url = this.orgInfo.logo
            this.$emit('upDataImg', this.orgInfo.logo)
            this.$router.push('/home/orgShop')
          }).catch(e => {
            this.$message.error(e.msg)
          })
        } else {
          this.$message.error('信息未填写完整，请确认')
        }
      });
    },
    /*
    * 保存基本信息
    * */
    saveForm() {
      this.$api.apiContent.mechanismSaveorupdate({
        token: this.$store.state.user.token,
        secretariat_address: this.orgInfo.address,
        major_num: this.orgInfo.msZZ,
        party_num: this.orgInfo.dyNum,
        party_name: this.orgInfo.dzbName,
        website: this.orgInfo.orgWeb,
        contacts: this.orgInfo.name,
        phone: this.orgInfo.phone,
        email: this.orgInfo.email,
        logo_url: this.orgInfo.logo,
      }).then(() => {
        this.$message.success('信息保存成功')
        this.$store.state.user.head_url = this.orgInfo.logo
        this.$emit('upDataImg', this.orgInfo.logo)
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
    /*上传图片*/
    setImg(obj) {
      console.log(obj)
      switch (obj.title) {
        case 'logo':
          this.orgInfo.logo = obj.url
          return
        case 'fc':
          this.formFc.img = obj.url
          return
      }
    },
    /*
    * 专题分类
    * */
    typeList() {
      this.$api.apiContent.typeList({
        token: this.$store.state.user.token,
      }).then(res => {
        this.typeArr = res.data
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
    /*
    * 获取机构基本信息
    * */
    getOrgInfo() {
      this.$api.apiContent.orgInfo({
        token: this.$store.state.user.token,
      }).then(res => {
        this.state = res.data.base_info.status
        this.reason = res.data.base_info.reason
        let end_time = []
        res.data.base_info.end_time.map(item => {
          end_time.push(item)
        })
        this.importInfo = {
          text1: res.data.base_info.name,
          text2: res.data.base_info.regist_no,
          text3: res.data.base_info.registered_capital,
          text4: res.data.base_info.unified_code,
          text5: res.data.base_info.address,
          text6: res.data.base_info.legal_person,
          text7: res.data.base_info.org_type,
          text8: res.data.base_info.business_unit,
          text9: res.data.base_info.chengli_time ,
          text10: res.data.base_info.administration,
          text11: res.data.base_info.registration_status,
          text12: res.data.base_info.range,
          text13: res.data.base_info.level,
          text14: res.data.base_info.examine,
          text15: end_time,
          text16: res.data.base_info.year,
          text17: res.data.base_info.conclusion,
        }
        if (res.data.detail_info) {
          this.orgInfo = {
            address: res.data.detail_info.secretariat_address,     //秘书处地址
            msZZ: res.data.detail_info.major_num,        //秘书处专职人员
            dyNum: res.data.detail_info.party_num,       //党员数量
            dzbName: res.data.detail_info.party_name,     //党支部名称
            orgWeb: res.data.detail_info.website,      //机构网站
            name: res.data.detail_info.contacts,        //联系人
            phone: res.data.detail_info.phone,       //联系电话
            email: res.data.detail_info.email,       //电子邮箱
            logo: res.data.detail_info.logo_url,        //上传LOGO
          }
        }
        this.fcArr = res.data.organization_info
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
    getOrgInfo2() {
      this.$api.apiContent.orgInfo({
        token: this.$store.state.user.token,
      }).then(res => {
        this.fcArr = res.data.organization_info
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
  }
}
</script>

<style scoped lang="scss">
.content-info {
  .form-title {
    height: 56px;
    padding: 0 30px;
    border-bottom: 2px solid #f2f2f2;
    position: relative;
    font-size: 18px;

    &:before {
      position: absolute;
      top: 17px;
      left: 15px;
      content: '';
      width: 6px;
      height: 22px;
      background-color: #f9aa0d;
    }

    span {
      font-size: 16px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #999999;
    }

    p {
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #333333;

      b {
        color: #c70005;
      }
    }
  }

  .reason {
    font-size: 24px;
    color: #c70005;
  }

  .form-step {
    padding: 20px 40px;

    span {
      width: 180px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #999999;
      background-color: #e8e8e8;
      border-radius: 21px;

      &.active {
        background-color: #f9aa0d;
        color: #fff;
      }
    }
  }

  .step-box {
    .step-title {
      .step-title-text {
        width: 179px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        font-size: 18px;
        font-weight: normal;
        font-style: italic;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        background: url(../../assets/img/title.png) no-repeat center;
      }

      .step-title-tips {
        flex: 1;
        padding: 10px;
        line-height: 16px;
        font-size: 12px;
        background-color: #fff4f4;
        border-radius: 4px;
        border: solid 1px #ffe8e8;
        color: #c70005;

        span {
          color: #999;
        }
      }
    }

    .tan-title {
      background-color: #ececec;
    }

    .tan-info {
      background-color: #f9f9f9;
    }

    .hr-solid {
      margin: 0 30px;
      border-bottom: 1px solid #f2f2f2;
    }

    .up-file-box {
      display: flex;
      align-items: center;

      .up-img {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 130px;
        height: 130px;
        position: relative;
        border: 1px solid #f9aa0d;
        border-radius: 130px;
        margin: 0 30px;
        overflow: hidden;

        //&:after {
        //  position: absolute;
        //  top: 0;
        //  right: 0;
        //  content: 'X';
        //  width: 20px;
        //  height: 20px;
        //  font-size: 12px;
        //  text-align: center;
        //  line-height: 20px;
        //  border-radius: 20px;
        //  color: #fff;
        //  background: #c70005;
        //  cursor: pointer;
        //}

        img {
          display: block;
          width: 130px;

          //&.logo {
          //  height: 130px;
          //  border-radius: 130px;
          //}
        }
      }

    }

    .file-tips {
      text-align: left;
      font-size: 12px;
      color: #c70005;
    }

    .demeanour-item {
      margin-bottom: 30px;
      padding: 20px 20px 10px;
      border: 1px solid #c70005;
      border-radius: 5px;

      div {
        //display: flex;
        //align-items: self-start;
        margin-bottom: 5px;

        span {
          display: block;
          width: 80px;
          line-height: 24px;

          b {
            padding: 0 14px;
          }
        }

        p {
          flex: 1;
          line-height: 24px;
        }

        img {
          flex: 1;
          display: block;
          width: auto;
          max-width: 100%;
          height: 200px;
          margin: 0 auto;
        }
      }

      .demeanour-item-btn {
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
    }
  }

  .add-item-btn {
    display: block;
    width: 150px;
    margin: 0 auto;
  }

  .operate {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-bottom: 50px;

    .operate-submit {
      width: 150px;
      height: 60px;
      background-color: #0087d4;
      border-radius: 30px;
      font-size: 16px;
      line-height: 30px;
      color: #ffffff;
    }

    .operate-next {
      width: 314px;
      height: 60px;
      margin-left: 50px;
      background-image: linear-gradient(90deg,
        #f9aa0d 0%,
        #e44730 100%),
      linear-gradient(
          #f9aa0d,
          #f9aa0d);
      background-blend-mode: normal,
      normal;
      border-radius: 30px;
      font-size: 16px;
      line-height: 30px;
      color: #ffffff;
    }
  }

  .step-solid {
    border-bottom: 1px solid #f2f2f2;
  }
}

.dislog-from {
  .up-file-box {
    display: flex;
    align-items: center;

    .up-img {
      margin: 0 30px;

      img {
        display: block;
        height: 130px;
      }
    }

  }
}
</style>
